import { Controller } from '@hotwired/stimulus';
import axios from 'axios';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      onUpdate: this.onUpdate.bind(this),
      // handle: '[data-sortable-handle]',
    });
  }

  disconnect() {
    this.sortable.destroy();
  }

  onUpdate(event) {
    const nuevaListaIdsOrdenados = Array.from(event.to.querySelectorAll(':scope [data-sortable-id]')).map((col) => (
      col.dataset.sortableId
    ));

    axios.post(this.urlValue, { orden: nuevaListaIdsOrdenados });
  }
}
